import { render } from "./EditShg.vue?vue&type=template&id=67224c6c&scoped=true"
import script from "./EditShg.vue?vue&type=script&lang=js"
export * from "./EditShg.vue?vue&type=script&lang=js"

import exportComponent from "/codebuild/output/src3194113096/src/coop-web/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67224c6c"]])

export default __exports__